export const GET_PROGRAM_TYPES = "GET_PROGRAM_TYPES";
export const GET_PROGRAM_TYPE_BY_ID = "GET_PROGRAM_TYPE_BY_ID";
export const UPDATE_PROGRAM_TYPE = "UPDATE_PROGRAM_TYPE";
export const DELETE_PROGRAM_TYPE = "DELETE_PROGRAM_TYPE";
export const CREATE_PROGRAM_TYPE = "CREATE_PROGRAM_TYPE";
